export const BASE_KEY = 'BACKGROUNDS';

export const backgroundsKeys = {
  all: () => [BASE_KEY] as const,
};
